angular.module('impactx.smartform').provider('SmartFormTemplateCache', function () {
    var self = this;
    var $http, $templateCache;
    var usageTypes = [];

    self.smartForms = {};
    self.registeredComponents = {};
    self.smartFormGridsterConfig = {};
    self.lastDeletedComponentFormIdentifier = '';
    self.lastDeletedComponent = {};
    self.smartFormService = {};

    self.initialize = function (usageTypesArray) {
        var injector = angular.injector(['ng']);
        $http = injector.get('$http');
        $templateCache = injector.get('$templateCache');
        usageTypes = usageTypesArray;
    };

    self.registerComponentTemplate = function (componentName, componentConfig) {
        initializeTemplate(componentConfig);
        extendComponentConfig(componentName, componentConfig);

        if (!self.registeredComponents[componentName]) {
            componentConfig.component = componentName;
            self.registeredComponents[componentName] = componentConfig;
        }
    };

    self.setDefaultSmartFormGridsterConfig = function (defaultConfig) {
        self.smartFormGridsterConfig = defaultConfig;
    };

    self.getDefaultSmartFormGridsterConfig = function () {
        return self.smartFormGridsterConfig;
    };

    self.createSmartFormGridsterConfig = function (layout) {
        if (layout) {
            var result = {};
            angular.copy(self.smartFormGridsterConfig, result);
            result.columns = layout.columns ? layout.columns : self.smartFormGridsterConfig.columns;

            return result;
        }
        return self.smartFormGridsterConfig;
    };

    self.insertComponent = function (smartFormIdentifier, component) {
        if (smartFormIdentifier && component) {
            if (self.registeredComponents[component.component]) {
                if (!self.smartForms[smartFormIdentifier]) {
                    self.smartForms[smartFormIdentifier] = {};
                }
                var cachedComponent = buildComponent(self.registeredComponents[component.component], component);
                self.smartForms[smartFormIdentifier][cachedComponent.identifier] = cachedComponent;
            }
        }
    };

    self.getComponent = function (smartFormIdentifier, component) {
        if (smartFormIdentifier && component) {
            var form = self.smartForms[smartFormIdentifier];
            var cachedComponent = form[component.identifier] ? form[component.identifier] : null;
            if (cachedComponent) {
                return buildComponent(cachedComponent, component);
            }
        }
        else {
            return self.registeredComponents[component.component];
        }
    };

    self.getComponents = function () {
        return self.registeredComponents;
    };

    self.getForm = function (smartFormIdentifier) {
        var smartForm = self.smartForms[smartFormIdentifier];
        if (!smartForm) {
            self.smartForms[smartFormIdentifier] = {};
        }
        return self.smartForms[smartFormIdentifier];
    };

    self.removeForm = function (smartFormIdentifier) {
        delete self.smartForms[smartFormIdentifier];
    };

    self.removeComponent = function (smartFormIdentifier, componentIdentifier) {
        var formFromIdentifier = self.smartForms[smartFormIdentifier];
        if (smartFormIdentifier && formFromIdentifier) {
            self.lastDeletedComponentFormIdentifier = smartFormIdentifier;
            self.lastDeletedComponent = formFromIdentifier[componentIdentifier];
            delete formFromIdentifier[componentIdentifier];
        }
        else {
            for (var formIdentifier in self.smartForms) {
                if (self.smartForms.hasOwnProperty(formIdentifier)) {
                    var formObject = self.smartForms[formIdentifier];
                    if (formObject[componentIdentifier]) {
                        self.lastDeletedComponentFormIdentifier = smartFormIdentifier;
                        self.lastDeletedComponent = formObject[componentIdentifier];
                        delete formObject[componentIdentifier];
                    }
                }
            }
        }
    };

    self.reviveComponent = function () {
        var form = self.smartForms[self.lastDeletedComponentFormIdentifier];
        form[self.lastDeletedComponent.identifier] = self.lastDeletedComponent;

        self.lastDeletedComponentFormIdentifier = '';
        self.lastDeletedComponent = {};
    };

    self.calculateRowPlacement = function (smartFormIdentifier) {
        var rowCount = -1, formObject = self.smartForms[smartFormIdentifier];
        for (var componentName in formObject) {
            if (formObject.hasOwnProperty(componentName)) {
                rowCount += formObject[componentName].layout.sizeY;
            }
        }

        if (rowCount < 0) {
            rowCount = 0;
        }
        else {
            rowCount += 1;
        }

        return rowCount;
    };

    function buildComponent(registeredComponent, sourceComponent) {
        // Merge prioritizes the rightmost object's values
        const component = angular.merge({}, registeredComponent, sourceComponent);
        // Incorrect copy of options => merges to highest amount instead of matching source
        // Corrected Here
        if(sourceComponent && sourceComponent.options && sourceComponent.component !== 'time') {
            component.options = [];
            if(sourceComponent.component === "select" && sourceComponent.options.length > 0)
            {
                component.options = sourceComponent.options;
            }
            else
            {
                for(let i = 0; i < sourceComponent.options.length; i++)
                {
                    component.options.push(angular.merge({}, registeredComponent.options[i], sourceComponent.options[i]));
                }
            }
        }
        /*
        must be done below for the case that there are no sourceComponent.Options
        overrides the component value with the value of the db record even if null!!!
         */
        if(sourceComponent.value === undefined || sourceComponent.value !== component.value)
        {
            component.value = sourceComponent.value;
        }
        return component;
    }

    function initializeTemplate(component) {
        $http.get(component.templateUrl, {
            cache: $templateCache
        }).then(function (template) {
            component.template = template.data;
        });
    }


    function extendComponentConfig(componentName, component) {
        component.identifier = '';
    }

    this.$get = ['SmartFormService', function (SmartFormService) {
        self.smartFormService = SmartFormService;

        return {
            usageTypes: usageTypes,
            initialize: self.initialize,
            registerComponentTemplate: self.registerComponentTemplate,
            setDefaultSmartFormGridsterConfig: self.setDefaultSmartFormGridsterConfig,
            getDefaultSmartFormGridsterConfig: self.getDefaultSmartFormGridsterConfig,
            createSmartFormGridsterConfig: self.createSmartFormGridsterConfig,
            insertComponent: self.insertComponent,
            getComponent: self.getComponent,
            getComponents: self.getComponents,
            getForm: self.getForm,
            removeForm: self.removeForm,
            removeComponent: self.removeComponent,
            reviveComponent: self.reviveComponent,
            calculateRowPlacement: self.calculateRowPlacement
        };
    }]
});


